const routes = {
    home: '/',
    orders: '/orders',
    article: '/article',
    gallery: '/gallery',
    login: '/login',
    newOrder: '/newOrder'
};

export default routes;
